var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"box"},[_c('activity-logs',{attrs:{"idUser":_vm.currentUser.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }